import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import DashboardAnalytics from "../pages/DashboardAnalytics";
import DashboardEcommerce from "../pages/DashboardEcommerce";
 

// //AuthenticationInner pages
import BasicSignIn from '../pages/AuthenticationInner/Login/BasicSignIn';
import CoverSignIn from '../pages/AuthenticationInner/Login/CoverSignIn';
import BasicSignUp from '../pages/AuthenticationInner/Register/BasicSignUp';
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from '../pages/AuthenticationInner/PasswordReset/BasicPasswReset';

import CoverPasswReset from '../pages/AuthenticationInner/PasswordReset/CoverPasswReset';
import BasicLockScreen from '../pages/AuthenticationInner/LockScreen/BasicLockScr';
import CoverLockScreen from '../pages/AuthenticationInner/LockScreen/CoverLockScr';
import BasicLogout from "pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from '../pages/AuthenticationInner/Logout/CoverLogout';
import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import CoverSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';
import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import CoverTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import AccessDenied from '../pages/AuthenticationInner/Errors/AccessDenied';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";


// //login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import ResetPasswordPage from "../pages/Authentication/ResetPassword";
import Logout from "../pages/Authentication/Logout";


// // User Profile
import UserProfile from "../pages/Authentication/UserProfile";

// Change Password - ADDED
import ChangePassword from "../pages/Authentication/ChangePassword";

// Audit Logs - ADDED
import AuditLogs from "../pages/AuditLogs";

// User Management - ADDED
import UserManagement from "../pages/UserManagement";

// Role Management - ADDED
import RoleManagement from "../pages/RoleManagement";

// Module Management - ADDED
import ModuleManagement from "../pages/ModuleManagement";

import SystemConfiguration from "../pages/SystemConfiguration";

// Agent Management - ADDED
import AgentManagement from "../pages/AgentManagement";

// Tenant Management - ADDED
import TenantManagement from "../pages/TenantManagement";

// Ticket Design Template - ADDED
import TicketDesignTemplate from "../pages/TicketDesignTemplate";

// Ticket Type Management - ADDED
import TicketTypeManagement from "../pages/TicketTypeManagement";

// Sinh Bộ Số & QR - ADDED
import SinhBoSoQr from "../pages/SinhBoSoQr";

// Prize Structure Management (Cơ cấu Giải thưởng) - ADDED
import PrizeStructure from "../pages/PrizeStructure";

// Draw Result Management (Kết quả Quay số) - ADDED
import DrawResult from "../pages/DrawResult";

// Prize Claim Dossier (Thẩm định Hồ sơ Trả thưởng) - ADDED
import ClaimDossier from "../pages/ClaimDossier";

// Payment Accounting (Kế toán Chi trả) - ADDED
import PaymentAccounting from "../pages/PaymentAccounting";

// Brand Management - ADDED
import BrandManagement from "../pages/BrandManagement";
import IssuancePlan from "../pages/IssuancePlan";
import ErrorPlanManagement from "../pages/ErrorPlanManagement";
import PrintHouseDelivery from "../pages/PrintHouseDelivery";

// Phân hệ Giao vé & Thu hồi vé ế (README_TICKETHANDLE.md — mục 4.8 và US-016→019) - ADDED
import TicketDeliveryManagement from "../pages/TicketDeliveryManagement";
// Mục 8.b, README_UPDATE.md — "Quản lý vé" (TicketManagement) đã được gộp vào TicketDeliveryManagement
// (1 màn duy nhất, hành động phân theo trạng thái phiếu). Không còn import/dùng component riêng —
// file vẫn giữ nguyên trên đĩa (chưa xoá), route /ticket-management bên dưới trỏ sang component gộp.
import TicketStockOverview from "../pages/TicketStockOverview";
import IssuancePlanReport from "../pages/Reports/IssuancePlanReport";
import TicketDeliveryByAgentReport from "../pages/Reports/TicketDeliveryByAgentReport";
import TicketRecallByAgentReport from "../pages/Reports/TicketRecallByAgentReport";
import AgentDebtReport from "../pages/Reports/AgentDebtReport";
import AgentDebtAdjustmentPage from "../pages/Reports/AgentDebtAdjustment";
import TicketRecallManagement from "../pages/TicketRecall";
import QrScanRecallPage from "../pages/TicketRecall/QrScanRecall";
import QrScanDeliveryPage from "../pages/TicketDeliveryManagement/QrScanDelivery";
// Muc 22, REQUIRE_FIXBUGS.md — UnsoldTicketCounterReview khong con duoc dang ky route (luong
// UnsoldTicketReturnRequest khong co du lieu, da doi sang luong TicketRecall). File component van
// giu nguyen tren disk (chua xoa entity/API backend) — chi go route + import o day.
import UnsoldTicketAppraisal from "../pages/UnsoldTicketAppraisal";
import UnsoldTicketWarehouseReport from "../pages/UnsoldTicketWarehouseReport";

// Notification Management - ADDED
import NotificationManagement from "../pages/NotificationManagement";

// Báo cáo phát hành vé số (RPT-001→018) + Quản lý nhà in — README.md mục 7, module
// IssuanceReporting (ticket-service). 6 trang tab-nhóm + 1 trang CRUD danh mục.
import IssuanceStock from "../pages/Reports/IssuanceReporting/IssuanceStock";
import DistributionRecall from "../pages/Reports/IssuanceReporting/DistributionRecall";
import ReconciliationDiscrepancy from "../pages/Reports/IssuanceReporting/ReconciliationDiscrepancy";
import AgentPrintHouseSummary from "../pages/Reports/IssuanceReporting/AgentPrintHouseSummary";
import IssuanceTicketLookup from "../pages/Reports/IssuanceReporting/IssuanceTicketLookup";
import PeriodSummaryClosing from "../pages/Reports/IssuanceReporting/PeriodSummaryClosing";
import PrintHouseManagement from "../pages/PrintHouseManagement";

// Ticket Lookup (tra cứu kết quả vé số qua QR — public) - ADDED
import TicketLookup from "../pages/TicketLookup";

// Lookup Portal (Cổng tra cứu kết quả — nhập tay số vé, public) - ADDED
import LookupPortal from "../pages/LookupPortal";

const authProtectedRoutes = [
  { path: "/dashboard-analytics", component: <DashboardAnalytics /> },
  // { path: "/dashboard-crm", component: <DashboardCrm /> },
  { path: "/dashboard", component: <DashboardEcommerce /> },
 
  // Audit Logs - ADDED
  { path: "/audit-logs", component: <AuditLogs /> },

  // User Management - ADDED
  { path: "/user-management", component: <UserManagement /> },

  // Role Management - ADDED
  { path: "/role-management", component: <RoleManagement /> },

  // Module Management - ADDED
  { path: "/module-management", component: <ModuleManagement /> },

  // System Configuration - ADDED
  { path: "/system-configuration", component: <SystemConfiguration /> },
  // //Job pages
 
  { path: "/profile", component: <UserProfile /> },

  // Change Password - ADDED
  { path: "/change-password", component: <ChangePassword /> },

  // Agent Management - ADDED
  { path: "/agent-management", component: <AgentManagement /> },

  // Tenant Management - ADDED
  { path: "/tenant-management", component: <TenantManagement /> },

  // Ticket Design Template - ADDED
  { path: "/ticket-design-template", component: <TicketDesignTemplate /> },

  { path: "/issuance-plans", component: <IssuancePlan /> },

  // Error Plan Management - tách từ tab "Quản lý kế hoạch lỗi" trong /issuance-plans (mục 10.2)
  { path: "/error-plan-management", component: <ErrorPlanManagement /> },

  // Lịch sử giao vé nhà in — README.md mục 7
  { path: "/print-house-deliveries", component: <PrintHouseDelivery /> },

  // Ticket Type Management - ADDED
  { path: "/ticket-type-management", component: <TicketTypeManagement /> },

  // Giao vé cho đại lý (vai trò Nhân viên Kho/Phát hành) - ADDED
  { path: "/ticket-delivery-management", component: <TicketDeliveryManagement /> },
  // Mục 8.3, README_UPDATE.md — giao vé bằng đọc mã QR qua ảnh.
  { path: "/ticket-delivery-management/qr-scan", component: <QrScanDeliveryPage /> },

  // Tồn kho vé theo kế hoạch (tách khỏi Giao vé cho đại lý — REQUIRE_FIXBUGS.md mục 8/10) - ADDED
  { path: "/ticket-stock-overview", component: <TicketStockOverview /> },

  // Module báo cáo — kỳ phát hành / giao vé đại lý / thu hồi vé ế theo đại lý (mục 24, REQUIRE_FIXBUGS.md) - ADDED
  // Mục 14.b, README_UPDATE.md — tách 3 báo cáo (trước gộp chung 1 trang có tab) thành 3 route
  // riêng. Giữ "/reports" cũ redirect sang báo cáo đầu tiên để không vỡ link/bookmark cũ.
  { path: "/reports", component: <Navigate to="/reports/issuance-plan" replace /> },
  { path: "/reports/issuance-plan", component: <IssuancePlanReport /> },
  { path: "/reports/ticket-delivery-by-agent", component: <TicketDeliveryByAgentReport /> },
  { path: "/reports/ticket-recall-by-agent", component: <TicketRecallByAgentReport /> },
  { path: "/reports/agent-debt", component: <AgentDebtReport /> },
  { path: "/reports/agent-debt-adjustment", component: <AgentDebtAdjustmentPage /> },

  // Báo cáo phát hành vé số (RPT-001→018) + Quản lý nhà in — README.md mục 7, module
  // IssuanceReporting (ticket-service). 18 báo cáo gộp thành 6 trang tab-nhóm theo chủ đề.
  { path: "/reports/issuance-stock", component: <IssuanceStock /> },
  { path: "/reports/distribution-recall", component: <DistributionRecall /> },
  { path: "/reports/reconciliation-discrepancy", component: <ReconciliationDiscrepancy /> },
  { path: "/reports/agent-printhouse-summary", component: <AgentPrintHouseSummary /> },
  { path: "/reports/issuance-ticket-lookup", component: <IssuanceTicketLookup /> },
  { path: "/reports/period-summary-closing", component: <PeriodSummaryClosing /> },
  { path: "/print-house-management", component: <PrintHouseManagement /> },

  // Thu hồi vé ế — công ty tự rút vé khỏi kho tổng, không chọn đại lý (REQUIRE_FIXBUGS.md mục 13.3) - ADDED
  { path: "/ticket-recall", component: <TicketRecallManagement /> },
  // Mục 8.3, README_UPDATE.md — thu hồi vé bằng cách đọc mã QR qua ảnh.
  { path: "/ticket-recall/qr-scan", component: <QrScanRecallPage /> },

  // Mục 8.b, README_UPDATE.md — "Quản lý vé" (xác nhận đại lý đã nhận vé, trước đây là trang riêng
  // TicketManagement — REQUIRE_FIXBUGS.md mục 13.2) đã gộp vào TicketDeliveryManagement. Route này
  // vẫn giữ nguyên (trỏ sang component gộp) để link cũ trong thông báo (`/ticket-management?deliveryId=`)
  // không bị vỡ.
  { path: "/ticket-management", component: <TicketDeliveryManagement /> },

  // Muc 22, REQUIRE_FIXBUGS.md — bo route "/unsold-ticket-counter-review" (US-016/US-017, luong
  // UnsoldTicketReturnRequest khong con du lieu). Component van con tren disk, chi khong dang ky
  // route/menu nua.

  // Thẩm định thu hồi vé ế (mục 22, REQUIRE_FIXBUGS.md) — nay dựa trên TicketRecall đã Confirmed.
  { path: "/unsold-ticket-appraisal", component: <UnsoldTicketAppraisal /> },

  // Lưu trữ vật lý & báo cáo nhanh thu hồi vé ế (US-019) - ADDED
  { path: "/unsold-ticket-warehouse-report", component: <UnsoldTicketWarehouseReport /> },

  // Sinh Bộ Số & QR - ADDED
  { path: "/sinh-bo-so-qr", component: <SinhBoSoQr /> },

  // Prize Structure Management (Cơ cấu Giải thưởng) - ADDED
  { path: "/prize-structure", component: <PrizeStructure /> },

  // Draw Result Management (Kết quả Quay số) - ADDED
  { path: "/draw-result", component: <DrawResult /> },

  // Prize Claim Dossier (Thẩm định Hồ sơ Trả thưởng) - ADDED
  { path: "/claim-dossiers", component: <ClaimDossier /> },

  // Hậu kiểm Trả thưởng (mục 7.2) — cùng component, chỉ đổi mode: chỉ liệt kê hồ sơ AgentPaid đã thẩm định phê duyệt
  { path: "/claim-dossier-post-audit", component: <ClaimDossier mode="postAudit" /> },

  // Payment Accounting (Kế toán Chi trả) - ADDED
  { path: "/payment-accounting", component: <PaymentAccounting /> },

  // Brand Management - ADDED
  { path: "/brand-management", component: <BrandManagement /> },

  // Notification Management - ADDED
  { path: "/notifications", component: <NotificationManagement /> },

  // Cổng tra cứu kết quả — nhập tay số vé + ký hiệu + chọn kỳ mở thưởng (giữ menu/layout quản trị) - ADDED
  { path: "/tra-cuu-ket-qua", component: <LookupPortal /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Tra cứu kết quả vé số qua QR (public, không cần đăng nhập) - ADDED
  // Token la 1 chuoi ma hoa AES-256-GCM (ky quay + so ve + ky hieu), xem QrTokenCodec ben ticket-service
  { path: "/v/:token", component: <TicketLookup /> },
  // LookupBaseUrl cau hinh o System Configuration co the KHONG co doan "/v" (VD:
  // "http://localhost:3000/" thay vi ".../v/") — luc do QR/URL tra cuu thuc te se la
  // "{lookupBaseUrl}/{token}" (khong co "/v"), xem QrGenerationJobConsumer.BuildQrUrl va
  // GenerateTicketSignatureQuery ben ticket-service. Dang ky them route goc de van khop dung man
  // tra cuu du LookupBaseUrl co hay khong co "/v", khong doi logic man TicketLookup.
  { path: "/:token", component: <TicketLookup /> },

  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPasswordPage /> },

  // //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-signup-basic", component: <BasicSignUp /> },
  { path: "/auth-signup-cover", component: <CoverSignUp /> },
  { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  // Route-guard theo Module/Permission (RBAC) — xem AuthProtected.tsx + services/modulePermission.
  // Nằm ở publicRoutes (không qua AuthProtected) để tránh vòng lặp redirect khi chính trang này
  // cũng bị kiểm tra quyền.
  { path: "/access-denied", component: <AccessDenied /> },


  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },


];

export { authProtectedRoutes, publicRoutes };


